<script setup>
import { ref } from "vue"
import { useVModels } from '@vueuse/core'
import { PencilSquareIcon } from '@heroicons/vue/24/solid'
import { DangerButton, PrimaryButton, Select, Text } from "@codinglabsau/ui"
import TargetSelector from "../Components/TargetSelector.vue"
import Modal from '@/Components/Inputs/BlockEditor/Extension/Components/Modal.vue'
import ToolbarButton from "@/Components/Inputs/BlockEditor/Extension/Components/ToolbarButton.vue"

const props = defineProps({
  href: {
    default: null,
  },
  button: {
    default: null
  },
  justify: {
    default: null,
  },
  deleteNode: {
    type: Function,
    required: true,
  },
  target: {
    default: null,
  }
})

let showDialogue = ref(false)

const emits = defineEmits(['update:href', 'update:button', 'update:justify', 'update:target'])

const {
  href: computedHref,
  button: computedButton,
  justify: computedJustify,
  target: computedTarget,
} = useVModels(props, emits)

const  deleteButton = () => {
  if (computedHref.value === '') {
    props.deleteNode()
    showDialogue.value = false
  }
}
</script>

<template>
  <ToolbarButton
    :icon="PencilSquareIcon"
    :label="__('Edit Button')"
    v-model="showDialogue"
  />
  <Modal v-model="showDialogue">
    <template #title>
      {{ __('Edit Button') }}
    </template>
    <div>
      <label for="href">{{ __('Link') }}</label>
      <Text
        v-model="computedHref"
        :description="__('Please provide a full url or a relative path e.g. \'/products/my-product-3255\'.')"
      />
    </div>
    <TargetSelector v-model="computedTarget"/>
    <div>
      <label for="button"> {{ __('Style') }}</label>
      <Select v-model="computedButton">
        <option value="primary" selected>{{ __('Primary') }}</option>
        <option value="secondary">{{ __('Secondary') }}</option>
      </Select>
    </div>
    <div>
      <label for="justify">{{ __('Align') }}</label>
      <Select v-model="computedJustify">
        <option value="start" selected>{{ __('Left') }}</option>
        <option value="center">{{ __('Center') }}</option>
        <option value="end">{{ __('Right') }}</option>
      </Select>
    </div>
    <PrimaryButton
      v-if="computedHref"
      @click.prevent="showDialogue = false"
      class="mt-2" as="button"
    >
      {{ __('Done') }}
    </PrimaryButton>
    <DangerButton
      v-else
      class="mt-2" as="button"
      @click.prevent="deleteButton"
    >
      {{ __('Delete') }}
    </DangerButton>
  </Modal>
</template>

